// extracted by mini-css-extract-plugin
module.exports = {"tasteInfoImage":"components-TasteInfo-TasteInfoImage-TasteInfoImage__tasteInfoImage--2OjvF"};